import styled from "styled-components";

export const PassoPasso = styled.section`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 43px;
  gap: 40px;

  #description {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    max-width: 1300px;
    gap: 30px;

    #desc-one {
      span {
        font-weight: 700;
        font-size: 12px;
        line-height: 122%;
        text-transform: uppercase;
        color: var(--orange);
      }

      h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 122%;
        color: var(--title);
      }

      img {
        width: 45%;
      }
    }

    #desc-two {
      display: flex;
      flex-direction: column;
      gap: 15px;

      #paragraph-desc-two {
        font-weight: 400;
        font-size: 14px;
        line-height: 160%;
        color: var(--paragraph);
      }

      span {
        font-weight: 700;
        font-size: 14px;
        line-height: 160%;
        color: var(--orange);
      }
    }
  }

  #solutions {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 1300px;
    gap: 16px;
    
    .buttons {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 300px;
      height: 188px;
      background-color: var(--white);
      gap: 10px;
      border: 1.38182px solid #c8d2df;
      border-radius: 2px;
      padding: 0 10px;
      margin: 0 auto;
      cursor: default;
      
      :hover {
        transition: all 0.3s;
        background-color: var(--orange);
        color: var(--white);

        h3 {
          color: var(--white);
        }
      }
      
      h3 {
        text-transform: uppercase;
        color: var(--orange);

      }
    }
  }

  @media (min-width: 601px) {
    padding-bottom: 100px;

    #description {
      flex-direction: row;
      justify-content: space-between;
      padding: 100px 0;

      #desc-one {
        width: 45%;

        span {
          font-size: 16px;
        }

        h1 {
          font-size: 48px;
        }
      }

      #desc-two {
        width: 45%;

        #paragraph-desc-two,
        span {
          font-size: 16px;
        }
      }
    }

    #solutions {
      .buttons {
        font-size: 18px;
        border: 2px solid #C8D2DF;
        height: 260px;

        h3 {
          font-size: 18px;
        }

        :hover {
            border: none;
        }
      }
    }
  }
`;